import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

const store = (state) => state.vendorPayrolls;
const payrollStore = (state) => state.payrolls;

const makeSelectVendorPayrollVisited = () => createSelector(
  store,
  ({ visited }) => visited,
);

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectFilterParams = () => createSelector(
  store,
  ({ filterParams }) => filterParams,
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  ({ tableTitleFilters }) => tableTitleFilters,
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectItemList = () => createSelector(
  store,
  (state) => R.sortBy(R.prop('index'), R.values(state.itemList)),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectPayrollConfigs = () => createSelector(
  payrollStore,
  ({ currentBranchConfigs }) => {
    const autoPayrollNumber = G.getConfigValueFromStore(
      GC.INVOICE_FLEET_VENDOR_PAYROLL_NUMBER_AUTOGENERATED,
      currentBranchConfigs,
    );

    const payrollDateRange = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_DATE_RANGE_DAYS,
      currentBranchConfigs,
      30,
    );

    const payrollDayFrom = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_DAY_FROM,
      currentBranchConfigs,
    );

    const payrollDayTo = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_DAY_TO,
      currentBranchConfigs,
    );

    const invoiceFilterDateRange = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_INVOICE_FILTER_DATE_RANGE_DAYS,
      currentBranchConfigs,
      30,
    );

    const defaultInvoiceStatusGuids = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_DEFAULT_INVOICE_STATUSES,
      currentBranchConfigs,
      [],
    );

    return {
      payrollDayTo,
      payrollDayFrom,
      payrollDateRange,
      autoPayrollNumber,
      invoiceFilterDateRange,
      defaultInvoiceStatusGuids,
    };
  },
);

const makeSelectUpdatedInvoice = () => createSelector(
  store,
  ({ updatedInvoice }) => updatedInvoice,
);

const makeSelectRecallDocumentsGuid = () => createSelector(
  store,
  ({ recallDocumentsGuid }) => recallDocumentsGuid,
);

const makeSelectFuelTollCounts = () => createSelector(
  store,
  ({ fuelTollCounts }) => fuelTollCounts,
);

const makeSelectAvailableCustomExportOptions = () => createSelector(
  store,
  ({ availableCustomExportTypes }) => {
    const options = [
      {
        label: 'First American Bank',
        value: GC.CUSTOM_EXCEL_EXPORT_FIRST_AMERICAN_BANK,
      },
    ];

    const availableOptions = R.filter(
      ({ value }) => R.includes(value, R.or(availableCustomExportTypes, [])),
      options,
    );

    return availableOptions;
  },
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectFilterParams,
  makeSelectFuelTollCounts,
  makeSelectPayrollConfigs,
  makeSelectUpdatedInvoice,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectRecallDocumentsGuid,
  makeSelectVendorPayrollVisited,
  makeSelectAvailableCustomExportOptions,
};
